export default {
	zhifujieguoyanzhengzhong: '支払結果は検証中ですので、お待ちください。',
	zhengzaiweininchaxun: 'お問い合わせ中です。お待ちいただきありがとうございました',
	qingshuruhuoxuanzenidechengshi: '目的地を入力または選択してください！',
	qingshuruchufadidian: '出発地を入力してください！',
	qingshurumudidi: '目的地を入力してください！',
	qinglijiyuwomenlianxin: '質問や予約のお手伝いが必要な場合は、今すぐお問い合わせください。',
	lijiyuwomenliaotian: '今すぐチャット',
	kehufuwurexian: 'お客様サービスホットライン',
	xuyaobangzhuma: 'お手伝いが必要ですか？',
	geiwomenfadianziyoujian: 'カスタマーサービスメール',
	chaxunbiaoge: '連絡先リスト',
	songxinren: 'メッセンジャー',
	xingming: '名前',
	gongsimingcheng: '会社名',
	youjiandizhi: 'メールアドレス',
	lianxidianhua: '連絡先電話番号',
	zhuti: '件名',
	liuyan: 'メッセージ',
	tijiao: '送信',
	lianxiwomen: 'お問い合わせ',
	shouyetishixinxi: '* 上記の価格はエコノミークラスの往復便のものです。実際の価格は異なる場合があります。条件が適用されます。',
	shangyiye: '前へ',
	xiayiye: '次へ',
	fangda: '拡大',
	suoxiao: '縮小',
	shengdantishi: '注文の送信に失敗しました。検索結果ページに戻って再検索します',
	qushouye: 'ホームページに移動',
	hangbanyishouqing: '便が完売しました',
	zhifushibai: '支払いに失敗しました',
	zhifuchaoshi: '支払タイムアウト',
	chongxinzhifu: '再支払い',
	yudingshibai: '予約に失敗しました！',
	dingdanzhengzaichulizhong: '注文は現在処理中です。更新してから確認してください！',
	yiwancheng: '完了',
	zhifufangshi: ' 支払い方法',
};
